/**
 * Config Filtering Utility
 *
 * Removes sensitive data from survey config before storing in localStorage/sessionStorage.
 * Uses a blocklist approach - keeps all config properties except explicitly sensitive ones.
 *
 * This approach ensures:
 * - New config properties work automatically (no code changes needed)
 * - Only truly sensitive data is filtered
 * - Single source of truth for what's sensitive
 */

/**
 * Filter out sensitive configuration data before storage
 *
 * @param config - Survey configuration object from YAML
 * @returns Filtered config safe for localStorage/sessionStorage
 */
export function filterSensitiveConfig(config: any): any {
  if (!config) return config;

  // Destructure to separate sensitive sections
  const { dashboard, api, ...safeConfig } = config;

  // Filter dashboard section - remove accessToken
  if (dashboard) {
    const { accessToken, ...safeDashboard } = dashboard;
    if (Object.keys(safeDashboard).length > 0) {
      safeConfig.dashboard = safeDashboard;
    }
  }

  // Filter API section - remove credentials
  if (api) {
    const { apiKey, secret, token, ...safeApi } = api;
    if (Object.keys(safeApi).length > 0) {
      safeConfig.api = safeApi;
    }
  }

  return safeConfig;
}
